/**
 * Auto Form Tracking — 폼 라이프사이클 추적
 * Form Started / Field Changed / Submitted / Abandoned
 * 절대 field value는 수집하지 않음 (PII 위험)
 */

export function initFormTracking(mixpanel) {
  var activeForms = new WeakMap(); // form element → { started: bool, dirty: bool }
  var dirtyFormCount = 0;

  function getFormInfo(formEl) {
    try {
      return {
        form_id: formEl.id || "",
        form_action: formEl.getAttribute("action") || "",
      };
    } catch (e) {
      return { form_id: "", form_action: "" };
    }
  }

  function getFieldInfo(fieldEl) {
    try {
      return {
        field_name: fieldEl.getAttribute("name") || fieldEl.id || "",
        field_type: fieldEl.type || fieldEl.tagName.toLowerCase(),
      };
    } catch (e) {
      return { field_name: "", field_type: "" };
    }
  }

  function findForm(el) {
    try {
      if (!el || typeof el.closest !== "function") return null;
      // 먼저 form 태그 안에 있는지 확인
      var form = el.closest("form");
      return form;
    } catch (e) {
      return null;
    }
  }

  // Form Started — 폼 내 첫 필드 포커스
  document.addEventListener(
    "focusin",
    function (event) {
      try {
        var target = event.target;
        if (!target) return;

        var isField =
          target.tagName === "INPUT" ||
          target.tagName === "TEXTAREA" ||
          target.tagName === "SELECT";
        if (!isField) return;

        var form = findForm(target);
        if (!form) return;

        var state = activeForms.get(form);
        if (state && state.started) return; // 이미 started

        activeForms.set(form, { started: true, dirty: false });

        var info = getFormInfo(form);
        var fieldInfo = getFieldInfo(target);

        var trackFn = function () {
          try {
            mixpanel.track("Auto Form Started", Object.assign({}, info, fieldInfo));
          } catch (e) {
            // 무시
          }
        };

        if (typeof requestIdleCallback === "function") {
          requestIdleCallback(trackFn);
        } else {
          setTimeout(trackFn, 0);
        }
      } catch (e) {
        // 무시
      }
    },
    { passive: true, capture: true },
  );

  // Field Changed
  document.addEventListener(
    "change",
    function (event) {
      try {
        var target = event.target;
        if (!target) return;

        var isField =
          target.tagName === "INPUT" ||
          target.tagName === "TEXTAREA" ||
          target.tagName === "SELECT";
        if (!isField) return;

        var form = findForm(target);
        if (!form) return;

        var state = activeForms.get(form);
        if (state) {
          if (!state.dirty) {
            state.dirty = true;
            dirtyFormCount++;
          }
        }

        var info = getFormInfo(form);
        var fieldInfo = getFieldInfo(target);

        var trackFn = function () {
          try {
            mixpanel.track("Auto Form Field Changed", Object.assign({}, info, fieldInfo));
          } catch (e) {
            // 무시
          }
        };

        if (typeof requestIdleCallback === "function") {
          requestIdleCallback(trackFn);
        } else {
          setTimeout(trackFn, 0);
        }
      } catch (e) {
        // 무시
      }
    },
    { passive: true, capture: true },
  );

  // Form Submitted
  document.addEventListener(
    "submit",
    function (event) {
      try {
        var form = event.target;
        if (!form || form.tagName !== "FORM") return;

        var info = getFormInfo(form);

        // 제출 후 상태 리셋
        var state = activeForms.get(form);
        if (state && state.dirty) {
          dirtyFormCount = Math.max(0, dirtyFormCount - 1);
        }
        activeForms.set(form, { started: false, dirty: false });

        var trackFn = function () {
          try {
            mixpanel.track("Auto Form Submitted", info);
          } catch (e) {
            // 무시
          }
        };

        if (typeof requestIdleCallback === "function") {
          requestIdleCallback(trackFn);
        } else {
          setTimeout(trackFn, 0);
        }
      } catch (e) {
        // 무시
      }
    },
    { passive: true, capture: true },
  );

  // Form Abandoned — beforeunload + dirty 폼 있을 때
  window.addEventListener("beforeunload", function () {
    try {
      if (dirtyFormCount <= 0) return;

      mixpanel.track("Auto Form Abandoned", {
        route_path: window.location.pathname,
      });
    } catch (e) {
      // 무시
    }
  });
}
